import { Computer,PhoneAndroid,SportsEsports,TwoWheeler,PhotoCamera,Headset,Watch,Cake } from "@mui/icons-material";


const Icons_Data = [
    {
        id: 1,
        path: 'womens',
        Icon:Computer,
    },
    {
        id: 2,
        path: 'man',
        Icon:PhoneAndroid,
    },
    {
        id: 3,
        path: 'man',
        Icon:SportsEsports,
    },
    {
        id: 4,
        path: 'man',
        Icon:TwoWheeler,
    },
    {
        id: 5,
        path: 'man',
        Icon:PhotoCamera,
    },
    {
        id: 6,
        path: 'man',
        Icon:Headset
    },
    {
        id: 7,
        path: 'man',
        Icon:Watch,
    },
    {
        id: 8,
        path: 'man',
        Icon:Cake,
    },
];

export default Icons_Data;